<template>
   <div class="terms" v-html="terms"></div>
  <!-- <div class="terms-container pt-5 col-12 mx-auto mb-5">
    <div class="row mx-0 col-12 col-lg-10 mx-auto">
      <h4 class="w-100 text-center text-white my-3 my-lg-4 page-main-title">
        Условия и соглашения
      </h4>
      <div class="col-12 mx-auto px-0">

        <div class="col-12 term-area-item page-main-block mb-4">
          <div class="col-12 col-lg-10 mx-auto px-0 term-title-block mb-4 mt-3">
            <p class="term-title">
              <span class="term-title-number">
                1.
              </span>
              <span>ОПРЕДЕЛЕНИЯ И ТЕРМИНОЛОГИЯ</span>
            </p>
          </div>
          <div class="col-12 col-lg-11 mx-auto term-texts-area mb-5 px-0">
            <p class="term-text-item">
              <span class="term-number">
                1.0.
              </span>
              <span class="term-text">
                Онлайн казинo «VIP Магнит», именуемое в дальнейшем «Казино» предоставляет 
                        игрокам доступ к игорным сервисам.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                1.1.
              </span>
              <span class="term-text">
                «Действующие законы» – это законы и правила, действующие на территории постоянного или 
                            временного проживания Игрока.Они регламентируют финансовые транзакции относительно счета 
                            Игрока в Казино, порядок посещения и использования Казино.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                1.2.
              </span>
              <span class="term-text">
                «Депозиты» – денежные пополнения личного игрового счета.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                1.3.
              </span>
              <span class="term-text">
                «Счет» – аккаунт игрока в Казино. К Счету прикрепляется личная информация Игрока: 
                        номер телефона, Никнейм и электронная почта, ссылка на интернет ресурсы (ID в соцсетях).
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                1.4.
              </span>
              <span class="term-text">
                «Выигрыш» – увеличение денежного баланса на счету Игрока в Казино в процессе игры на реальные
                            деньги.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                1.5.
              </span>
              <span class="term-text">
                «Логин» и «Пароль» – это данные для доступа к аккаунту Игрока в Казино. 
                            Эти данные указываются Игроком при регистрации.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                1.6.
              </span>
              <span class="term-text">
                «Снятие» – вывод определенной денежной суммы с игрового счета Игрока на валютный. 
                            Исходящая транзакция может быть проведена только Игроком лично.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                1.7.
              </span>
              <span class="term-text">
                «Бонус» – денежное поощрение от Казино, начисленное на Счет игрока.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                1.8.
              </span>
              <span class="term-text">
                Вы» – обладатель аккаунта и Игрок Казино.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                1.9.
              </span>
              <span class="term-text">
                \"Остаться в плюсе\" - означает, что игрок в процессе игры или игр остался в выигрыше, 
                                и сумма выводов превышает сумму пополнения.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                1.10.
              </span>
              <span class="term-text">
                \"Промо-код\" - код для получения бонуса игроку.
              </span>
            </p>
          </div>
        </div>

        <div class="col-12 term-area-item page-main-block mb-4">
          <div class="col-12 col-lg-10 mx-auto px-0 term-title-block mb-4 mt-3">
            <p class="term-title">
              <span class="term-title-number">
                2
              </span>
              <span>Предмет соглашения между казино и игроком</span>
            </p>
          </div>
          <div class="col-12 col-lg-11 mx-auto term-texts-area mb-5 px-0">
            <p class="term-text-item">
              <span class="term-number">
                1.0.
              </span>
              <span class="term-text">
                Игрок должен прочитать и согласиться с Правилами и Условиями настоящего пользовательского 
                соглашения. Прежде чем игрок может стать активным, зарегистрированным Игроком VIP Magnit и сможет 
                пользоваться услугами на сайте, ему следует подтвердить свое согласие со всеми, ниже перечисленными в 
                данном Соглашении, Правилами и Условиями.<br>VIP Magnit может время от времени вносить изменения в 
                условия настоящего Соглашения, публикуя измененные условия на сайте. Клиент обязан проверить и 
                ознакомиться с внесенными изменениями. Любое изменение вступает в силу со дня опубликования на сайте. 
                Продолжая пользоваться Интернет-сайтом, Сервисом или Программным обеспечением, предлагаемым VIP Magnit,
                 игрок соглашается с положениями настоящего Соглашения, а также с последними изменениями к нему. 
                 Если игрок не соглашается с изменениями Правил и Условий настоящего Соглашения, игрок не должен 
                 использовать наши Услуги и обязан немедленно сообщить нам в письменной форме.<br>VIP Magnit оставляет 
                 за собой право вводить определенные условия о допуске Игроков к играм (например, минимальное количество
                  завершенных игр, проверка платежей) и продлевать или изменять услуги на веб-сайте в любое время.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                2.0.
              </span>
              <span class="term-text">
                Регистрация и совершение ставок в казино подразумевают согласие игрока с данными правилами, 
                        а также правилами игр и прочими положениями.В игровом профиле требуется указать свою электронную
                        почту, номер мобильного телефона, ID социальной странички, придумать логин и пароль.
                        Вся информация об игроках является строго конфиденциальной.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                2.1.
              </span>
              <span class="term-text">
                Забыв свой логин или пароль от личного кабинета, игрок обязан зайти на наш сайт, нажать 
                        &#171; Забыли пароль? &#187;
                        и следовать инструкциям по восстановлению доступа к аккаунту. В противном случае логин и пароль 
                        не будут высланы игроку. Также игрок обязуется хранить в секрете информацию о
                        своей учетной записи от всех лиц, за исключением операторов, в ранее описанном случае.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                2.1.1.
              </span>
              <span class="term-text">
                Пользователь несет ответственность за безопасность использования и хранения имени 
                пользователя и пароля к аккаунту игрока. VIP Magnit не несет ответственности за любые злоупотребления 
                аккаунта игрока третьими лицами, в связи с умышленным, небрежным или случайным выявлением игроком 
                регистрационных данных.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                2.2.
              </span>
              <span class="term-text">
                Регистрация на сайте подразумевает, что игрок ознакомился с правилами и согласен с ними.
              </span>
            </p>
          </div>
        </div>

        <div class="col-12 term-area-item page-main-block mb-4">
          <div class="col-12 col-lg-10 mx-auto px-0 term-title-block mb-4 mt-3">
            <p class="term-title">
              <span class="term-title-number">
                3
              </span>
              <span>Общие соглашения и правила</span>
            </p>
          </div>
          <div class="col-12 col-lg-11 mx-auto term-texts-area mb-5 px-0">
            <p class="term-text-item">
              <span class="term-number">
                3.0.
              </span>
              <span class="term-text">
                Один зарегистрированный в системе игровой счет соответствует конкретному физическому адресу.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                3.1.
              </span>
              <span class="term-text">
                Услугами могут пользоваться исключительно пользователи, достигшие совершеннолетия (18 лет).
                 Если игрок  является несовершеннолетним, просим покинуть сайт. Игра на деньги предназначена 
                 исключительно для пользователей старше 18 лет. В противном случае операция по выводу денежных средств
                  не будет осуществляться, и аккаунт пользователя будет заблокирован.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                3.2.
              </span>
              <span class="term-text">
                VIPMagnit имеет право потребовать от Игрока документ, подтверждающий его возраст, 
                        или отказать Игроку в участии в играх, если имеются сомнения в возрасте клиента. Ни при каких 
                        обстоятельствах VIP Magnit не несет ответственности за злоупотребления, а также за участие 
                        в игре несовершеннолетних.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                3.3.
              </span>
              <span class="term-text">
                Минимальная сумма пополнения Счета Игрока – 10 рублей
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                3.4.1.
              </span>
              <span class="term-text">
                Максимальное пополнение за раз 15000 рублей.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                3.5.
              </span>
              <span class="term-text">
                Минимальная сумма выплаты 200 рублей на все методы.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                3.5.1.
              </span>
              <span class="term-text">
                Максимальная сумма выплаты 50000 рублей за один перевод.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                3.6.
              </span>
              <span class="term-text">
                В процессе игры Игрок не должен использовать не обнаруженные баги или ошибки
                                программного обеспечения в каких-либо целях. При обнаружении данного нарушения аккаунт
                                Игрока будет заблокирован, а выигрыши аннулированы.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                3.7.
              </span>
              <span class="term-text">
                Заявка на вывод средств оформляется в разделе «Выплата».Необходимо выбрать платежную систему,
                                предоставить данные для выплаты и в специальной строке указать сумму вывода.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                3.8.
              </span>
              <span class="term-text">
                Выводы с бонусных средств осуществляются в течение 24 часов с момента запроса на вывод.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                3.9.
              </span>
              <span class="term-text">
                ВНИМАНИЕ! Администрация не рекомендует пополнять счет и выводить средства со счета 
                        посредством электронных кошельков, не принадлежащих владельцу аккаунта. Служба безопасности 
                        компании имеет право рассматривать подобного рода пополнения как мошеннические действия и 
                        блокировать движения по счету без предупреждения. Администрация имеет право отказать в выводе 
                        средств на реквизиты,не принадлежащие владельцу счета.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                3.10.
              </span>
              <span class="term-text">
                Выводы личных денежных средств осуществляется в течение 5-20 минут, но иногда могут быть 
                        очереди на проверку, поэтому Ваш вывод может задерживается на час.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                3.11.
              </span>
              <span class="term-text">
                При возникновении проблем в платежной системе, например если игрок пополнил или сделал вывод,
                            но он не дошёл и прошло более чем 3 дня, казино не можем проверить или перевести деньги.
              </span>
            </p>
          </div>
        </div>

        <div class="col-12 term-area-item page-main-block mb-4">
          <div class="col-12 col-lg-10 mx-auto px-0 term-title-block mb-4 mt-3">
            <p class="term-title">
              <span class="term-title-number">
                4
              </span>
              <span>Участие в казино и игровой процесс</span>
            </p>
          </div>
          <div class="col-12 col-lg-11 mx-auto term-texts-area mb-5 px-0">
            <p class="term-text-item">
              <span class="term-number">
                4.0.
              </span>
              <span class="term-text">
                Игрок осознает возможные финансовые риски во время игры в Казино на реальные деньги и несет 
                        за них ответственность.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                4.1.
              </span>
              <span class="term-text">
                При возникновении технических проблем в платежной системе Казино в праве отменить выплату 
                        Игрока с возвратом суммы на его игровой счет.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                4.2.
              </span>
              <span class="term-text">
                Мы сохраняем за собой право задержать 30% денежных средств, в случаи, если после внесения
                        депозита игрок не делает никаких ставок, а затем отправляет заявку на вывод. Вывод должен быть 
                        на 30% больше или меньше суммы пополнения. В противном случае данный процент вычтет 
                        администрация.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                4.3.
              </span>
              <span class="term-text">
                Мы оставляем за собой право запросить у клиента идентификационные данные (паспортные данные, 
                        подтверждение номера телефона и т.д.) если есть какие-то проблемы  или если это необходимо 
                        для казино.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                4.4.
              </span>
              <span class="term-text">
                После предоставления Игроком необходимых документов начинается их проверка. Администрация 
                    Казино оставляет за собой право запрашивать документы игроков в любой момент. Это делается для 
                    обеспечения безопасности платежей и выявления мошенничества. В ответ на запрос верификации Игрок 
                    должен передать Казино читабельные копии требуемых документов для подтверждения собственной 
                    личности.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                4.5.
              </span>
              <span class="term-text">
                Счет Игрока, уличенного в мошенничестве, будет заблокирован с последующим прекращением выплат
                    по нему.Для подробного ознакомления с процедурой идентификации свяжитесь со службой поддержки.
                    В отдельных случаях может потребоваться подтверждение владением банковской картой и/или кошельком, 
                    на который делается вывод выигранных средств.В случае выявления нарушений вышеперечисленных правил 
                    — казино оставляет за собой право удаления аккаунта с аннулированием игрового баланса.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                4.6.
              </span>
              <span class="term-text">
                Игрок гарантирует предоставить достоверную, точную, актуальную и полную 
                информацию о личности в процессе регистрации. Фальшивые данные и любая ложная информация, вводящая 
                в заблуждение, будет расцениваются, как попытка мошенничества. VIPMagnit оставляет за собой право 
                проверить данные Игрока и любую указанную клиентом информацию.
                В целях борьбы с мошенничеством и отмыванием денег,правила нашего казино предусматривают 
                    идентификацию каждого пользователя и запрещается регистрация нескольких аккаунтов одним игроком.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                4.6.1.
              </span>
              <span class="term-text">
                Пользователь подтверждает, что все предоставленные данные являются актуальными.
                 В случае изменения персональных данных, адреса e-mail пользователь обязуется немедленно указать новые
                  данные на сайте VIPMagnit (на аккаунте игрока или об к  г.м ). Пользователь несет ответственность 
                  за передачу информации VIPMagnit об изменениях персональных данных.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                4.6.2.
              </span>
              <span class="term-text">
                Клиент не может зарегистрировать игровой аккаунт, если он/она уже имеет активный аккаунт 
                на сайте VIPMagnit. На одно лицо может быть зарегистрирован исключительно один игровой аккаунт. 
                Использование более чем одного аккаунта игрока строго запрещено. VIPMagnit оставляет за собой право 
                заблокировать аккаунт игрока в любое время и отменить все транзакции по отношению к любому пользователю,
                 который зарегистрировал более одного игрового аккаунта на свое имя или под разными именами, 
                 в том случае, если VIPMagnit имеет основания подозревать, что регистрация нескольких аккаунтов
                  была предпринята с целью обмана.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                4.7.
              </span>
              <span class="term-text">
                Предоставление заведомо ложной информации (включительно с опечатками) при регистрации или 
                    общении с операторами может послужить причиной аннуляции выигрыша Игрока и блокировки его аккаунта.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                4.7.1
              </span>
              <span class="term-text">
                В процессе регистрации пользователь обязан предоставить VIPMagnit  правильные данные
                 удостоверяющие личность, актуальный e-mail адрес и номер телефона.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                4.8.
              </span>
              <span class="term-text">
                Игрок несет полную ответственность за операции, связанные с персональным игровым счетом.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                4.9.
              </span>
              <span class="term-text">
                Онлайн-казино не несет ответственности за неправильно указанные данные при выводе денежных 
                        средств, а также при пополнении на неправильные номера электронных кошельков.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                4.10.
              </span>
              <span class="term-text">
                При возникновении проблем в платежной системе, например если игрок пополнил или сделал вывод,
                        но он не дошёл и прошло более чем 3 дня, казино не можем проверить или перевести деньги.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                4.11.
              </span>
              <span class="term-text">
                Мы не несем ответственность за неправильно указанные данные при пополнении на неправильные 
                            номера QIWI, которые были изменены на нашем сайте.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                4.12.
              </span>
              <span class="term-text">
                Соглашаясь на получение какого-либо бонуса, игрок обязан ознакомиться с условиями бонусной 
                        политики онлайн-казино и соблюдать все условия.Ознакомиться с бонусной политикой можно у 
                        операторов казино либо у менеджеров, работающих с Вами.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                4.13.
              </span>
              <span class="term-text">
                За прямое либо косвенное оскорбление работающего персонала полагается блокировка на 24 часа,
                            с блокировкой денежных средств на Вашем счету.
              </span>
            </p>
          </div>
        </div>

        <div class="col-12 term-area-item page-main-block mb-4">
          <div class="col-12 col-lg-10 mx-auto px-0 term-title-block mb-4 mt-3">
            <p class="term-title">
              <span class="term-title-number">
                5
              </span>
              <span>Акции и Бонусы.Условия по бесдепозитным счетам</span>
            </p>
          </div>
          <div class="col-12 col-lg-11 mx-auto term-texts-area mb-5 px-0">
            <p class="term-text-item">
              <span class="term-number">
                5.0.
              </span>
              <span class="term-text">
                Победитель Казино соглашается на участие в тематических мероприятиях, организованных и 
                        оплаченных администрацией Казино.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                5.1.
              </span>
              <span class="term-text">
                Применение мошеннических методов для получения бонуса лишает Игрока права на любые 
                        вознаграждения.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                5.2.
              </span>
              <span class="term-text">
                Правила бонусной политики действительны для всех акций Казино. Любая проводимая акция может 
                        иметь дополнительные условия, не противоречащие Правилам и условиям начисления бонусов.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                5.3.
              </span>
              <span class="term-text">
                Бездепозитный бонус получают Игроки за выполнение действий, которые определены Условиями 
                            Акции.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                5.4.
              </span>
              <span class="term-text">
                Депозитный Бонус начисляется на внесенный Игроком Депозит. При расчете величины депозитного
                         Бонуса учитывается сумма пополнений и выводов за всю игровую историю игрока.Размер Депозита,
                         величина Бонуса и вейджер отыгрыша закрепляются в Правилах Акции.
              </span>
            </p>
          </div>
        </div>

        <div class="col-12 term-area-item page-main-block mb-4">
          <div class="col-12 col-lg-10 mx-auto px-0 term-title-block mb-4 mt-3">
            <p class="term-title">
              <span class="term-title-number">
                6
              </span>
              <span>Правила по акциям и бонсным программам</span>
            </p>
          </div>
          <div class="col-12 col-lg-11 mx-auto term-texts-area mb-5 px-0">
            <p class="term-text-item">
              <span class="term-number">
                6.0.
              </span>
              <span class="term-text">
                На сайте имеются несколько бонусных программ, которые дают возможность игроку выиграть 
                            денежные средства, не совершая депозит своими личным средствами.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                6.1.
              </span>
              <span class="term-text">
                Мы сохраняем за собой право приостанавливать, отзывать или отменять любые выплаты или 
                        выигрыши, связанные с бонусными денежными средствами, полученными от казино, при наличии у нас 
                        подозрений в том, что Вы пытаетесь ими злоупотреблять. Отмененные выплаты с бонусных средств 
                        казино не подлежат возврату.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                6.2.
              </span>
              <span class="term-text">
                При выигрыше с одного бонуса можно снять любую сумму до 10000руб., остальная сумма будет
                            списана и аннулирована.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                6.3.
              </span>
              <span class="term-text">
                \"Промо-код\" - одноразовый код, по которому игроку начисляются бездепозитные денежные 
                    средства. Сами бонусные средства не подлежат выводу. Можно снять только то что выиграли с бонуса.
                     При выигрыше с одного бонуса можно снять любую сумму. , остальная сумма будет списана
                     и аннулирована. Средства, полученные через промо-код, но не использованные в течение двух недель, 
                     будут аннулированы.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                6.4.
              </span>
              <span class="term-text">
                \"Колесо\" - Бонусная программа \"Колесо Фортуны\" дается индивидуально, тем игрокам, 
                        кто активно пополнял баланс и играл. Выигрыш с Колеса игрок имеет право выводить на 30% больше 
                        или меньше бонусной суммы. В противном случае, при выводе Казино оставляет за собой право вычест
                         данный процент самостоятельно.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                6.5.
              </span>
              <span class="term-text">
                \"Кэшбек\" - дается при случае проигрыша той суммы, которую Вы пополнили на Ваш счет, 
                    в случае проигрыша боннусных денег кэшбек не дается. Игрок имеет право снять кешбек без процентов.
              </span>
            </p>
          </div>
        </div>

        <div class="col-12 term-area-item page-main-block mb-4">
          <div class="col-12 col-lg-10 mx-auto px-0 term-title-block mb-4 mt-3">
            <p class="term-title">
              <span class="term-title-number">
                7
              </span>
              <span>Политика оплаты и операции по пополнения личных счетов</span>
            </p>
          </div>
          <div class="col-12 col-lg-11 mx-auto term-texts-area mb-5 px-0">
            <p class="term-text-item">
              <span class="term-number">
                7.0.
              </span>
              <span class="term-text">
                Играть в автоматы на реальные деньги в онлайн Казино можно после внесения первого депозита. 
                        Процедура внесения денег на счет проходит моментально. Задержки могут быть только со стороны 
                        выбранной вами платежной системы в случае возникновения технических неполадок.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                7.1.
              </span>
              <span class="term-text">
                Мы не взимаем комиссию за депозит. Это может сделать только платежная система, которую вы
                        используете для ввода.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                7.2.
              </span>
              <span class="term-text">
                Чтобы пополнить счет в нашем казино необходимо:<br>
                        <span style='text-decoration: underline;' class='d-inline-block pl-3 pl-sm-4 pl-lg-5'>
                        1. На сайте выбрать раздел «Депозит» <br>
                        2. Кликнуть по иконке платежной системы, которую вы выбираете<br>
                        3. Ввести сумму платежа и нажать «Пополнить» <br>
                        4. В открывшемся окне для внесения депозита выбрать валюту пополнения и заполнить поле 
                        \"Контактная информация\". После соглашения с пользовательскими условиями нажать кнопку 
                        «Оплатить»<br>
                        5. Ввести номер карты или платежного кошелька выбранной системы, и через несколько секунд 
                        средства будут зачислены на ваш игровой счет.</span>
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                7.3.
              </span>
              <span class="term-text">
                На кошельке выбранной вами платежной системы обязательно должны быть деньги, иначе его 
                        использование для пополнения в нашем казино будет невозможным.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                7.4.
              </span>
              <span class="term-text">
                QIWI - кошелек. По нему Вы можете совершить платеж без комиссий, заранее уточнив номер нашего
                        Киви - кошелька в разделе \"Касса\". Укажите Ваш логин при переводе на кошелек, и платеж будет
                                зачислен моментально на тот логин, который Вы указали.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                7.5.
              </span>
              <span class="term-text">
                VISA/MASTERCARD - чтобы осуществить платеж нужно иметь платежную карту в любой валюте.
                        При пополнении через банковскую карту снимается комиссия в размере 4% от суммы пополнения
                        САМОЙ ПЛАТЕЖНОЙ СИСТЕМОЙ, а не Казино. В зависимости от Вашего банка и платежной системы
                        платежи могут идти от 15 минут до 3 суток. Если платеж в течение 3 суток (72 часа) не поступил
                        на Ваш игровой счет, он вернется Вам на карту, с который Вы совершали операцию по переводу д
                        енежных средств.
              </span>
            </p>
          </div>
        </div>

        <div class="col-12 term-area-item page-main-block mb-4">
          <div class="col-12 col-lg-10 mx-auto px-0 term-title-block mb-4 mt-3">
            <p class="term-title">
              <span class="term-title-number">
                8
              </span>
              <span>Политика вывода денежных средств и Аннулирования со счетев игроков</span>
            </p>
          </div>
          <div class="col-12 col-lg-11 mx-auto term-texts-area mb-5 px-0">
            <p class="term-text-item">
              <span class="term-number">
                8.0.
              </span>
              <span class="term-text">
                Выводы осуществляются исключительно на QIWI - кошельки либо на карты Виза.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                8.1.
              </span>
              <span class="term-text">
                Выводы на QIWI кошелек переводятся без снятия комиссий.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                8.2.
              </span>
              <span class="term-text">
                При выплатах на карту Виза снимается комиссия в размере 1% от общей суммы выплаты.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                8.3.
              </span>
              <span class="term-text">
                Запросы на выплаты не на QIWI Кошелек, Банковскую Карту, либо Яндекс Кошелек будут возвращены
                            на игровой баланс игрока.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                8.4.
              </span>
              <span class="term-text">
                После предупреждения о том, что были указаны не QIWI либо Виза, следующий запрос на снятие 
                            будет заморожен до выяснения обстоятельств.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                8.5.
              </span>
              <span class="term-text">
                Мы сохраняем за собой право задержать и/или прекратить обработку запроса на вывод, пока 
                            проверка не будет доведена до конца.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                8.6.
              </span>
              <span class="term-text">
                Мы сохраняем за собой право аннулировать выводы денежных средств, если вывод нарушал 
                            какое-либо правило Казино.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
                8.7.
              </span>
              <span class="term-text">
                Оформить заявку на получение выигрыша Вы можете в разделе «Выплата», расположенном в 
                            панели казино.
              </span>
            </p>
            <p class="term-text-item">
              <span class="term-number">
              </span>
              <span class="term-text">
                <strong>Мы оставляем за собой право менять условия бонусных акций, правила и политику казино.
                            </strong>
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div> -->
</template>

<script>
export default {
  name: 'Terms',

  computed: {
    terms () {
      let terms = this.$store.getters.terms;
      if (!terms) {
        this.$store.dispatch('getTerms')
        return this.$store.getters.terms
      }
      return terms;
    }
  },

}
</script>

<style>
  .page-main-block{
    min-height: 85px;
  }
  .term-text,.term-number{
    font-size: 14px;
    color : #ffffff;
  }
  .term-text{
    line-height: 30px;
  }
  .term-text-item{
    margin-bottom: 7px !important;
  }
  .term-area-item{
    border-top: 1px solid #1f1f1f;
  }
  .term-title{
    text-align: center;
    margin: auto;
    font-size: 15px;
    text-transform: capitalize;
    padding: 5px 10px;
  }
  .description {
    background-color: rgba(62, 101, 129, 0.2);
    border-radius: 10px;
  }

  .description span {
    line-height: 2;
    font-size: 14px;
    color: white;
  }

  .terms-title {
    color: white;
    font-size: 20px;
  }

  .terms-logo {
    width: 60px;
    height: auto;
  }
</style>
